import { render } from "./AssistantIcon.vue?vue&type=template&id=4cc0b90b&scoped=true"
import script from "./AssistantIcon.vue?vue&type=script&lang=js"
export * from "./AssistantIcon.vue?vue&type=script&lang=js"

import "./AssistantIcon.vue?vue&type=style&index=0&id=4cc0b90b&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc0b90b"],['__file',"src/Components/ChatWidget/ChatAssistant/AssistantIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cc0b90b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cc0b90b', __exports__)) {
    api.reload('4cc0b90b', __exports__)
  }
  
  module.hot.accept("./AssistantIcon.vue?vue&type=template&id=4cc0b90b&scoped=true", () => {
    api.rerender('4cc0b90b', render)
  })

}


export default __exports__